import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";


export const getSiteSettings = async (name="user") => {
  try {
    const response = await api.get(`${API_URL}/siteSetting/${name}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

export const addSiteSetting = async (siteSetting,name="user") => {
  try {
    const response = await api.post(`${API_URL}/siteSetting/${name}`, siteSetting,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

